import React from 'react';
import './Acoustics.css';

interface SliderProps {
    name: string,
    value: number,
    min: number,
    max: number,
    step: number,
    onChangeFunc(e: number): void,
}

const Slider: React.FC<SliderProps> = (props: SliderProps) => {

    function updateSliderValue(e: React.FormEvent<HTMLInputElement>) {
        var value = Number(e.currentTarget.value);

        if (value >= props.min && value <= props.max) props.onChangeFunc(value);
    }

    function updateTextValue(e: React.FormEvent<HTMLInputElement>) {
        var value = Number(e.currentTarget.value);

        props.onChangeFunc(Math.min(Math.max(value, props.min), props.max));
    }

    return(
        <div style={{ display: 'flex', flexDirection:'column', marginBottom: '20px' }}>
            <label aria-hidden style={{ fontSize: 20 }}>{props.name}</label>
            <div style={{ display:'flex' }}>
                <input type='range' className='slider'
                    value={props.value}
                    min={props.min} 
                    max={props.max}
                    step={props.step}
                    aria-live="assertive"
                    aria-label={props.name + ' set at ' + props.value}
                    onChange={updateSliderValue}
                />
                <input type='number' className='inputBox'
                    value={props.value}
                    min={props.min} 
                    max={props.max}
                    step={props.step}
                    aria-live="assertive"
                    aria-label={props.name + ' set at ' + props.value}
                    onChange={updateTextValue}
                />
            </div>
        </div>
    )
}

export default Slider;